'use client';

import { clsx } from 'clsx';
import { useModal } from '../../hooks/use-modal';
import styles from './modal.module.css';
import { ModalProps } from './modal.props';

export const Modal = ({ isOpen, children, onClose, ...props }: ModalProps) => {
	const { dialogRef, contentRef } = useModal({ isOpen, onClose });

	return (
		<dialog
			ref={dialogRef}
			className={clsx(styles.dialog, {
				[styles.open]: isOpen,
			})}
		>
			<div {...props} ref={contentRef}>
				{children}
			</div>
		</dialog>
	);
};
